import { createSelector } from 'reselect';
import pickBy from 'lodash/pickBy';

// selector filters if user is logged in and quiz is completed
export const selectedUserStatsByQuizCompleted = createSelector(
  [
    (state) => state.user.statsByQuiz,
  ],
  (statsByQuiz) => pickBy(statsByQuiz,
    (quizStats) => quizStats.attempted === quizStats.total_questions),
);

export default selectedUserStatsByQuizCompleted;
